import * as React from "react"
import { useMatch } from "react-router-dom"
import { Calendar, ChartPie, ClipboardList, Divide, Home, ListMusic, MapPin, MessageSquare, Music, Settings, Users } from "lucide-react"

import { NavMain } from './nav-main'
import { NavSecondary } from "./nav-secondary"
import { NavUser } from "./nav-user"
import { Sidebar, SidebarContent, SidebarFooter, SidebarHeader } from "~/ui/sidebar"
import { OrgSwitcher } from "./org-switcher"
import { useViewer } from "~/auth/use-viewer"
import {
  dashboardPath,
  usersPath,
  playlistsPath,
  reportingPath,
  schedulesPath,
  tracksPath,
  voiceMessagesPath,
  voicePlaylistRequestsPath,
  zonesPath,
  organizationSettingsPath,
} from '~/common/paths'

export function AppSidebar({ ...props }: React.ComponentProps<typeof Sidebar>) {
  const { viewer } = useViewer()

  // If there is no authenticated viewer yet, don't render the sidebar
  if (!viewer) {
    return null
  }

  const navMain = [
    {
      title: "Dashboard",
      url: dashboardPath({}),
      icon: Home,
      isActive: useMatch(dashboardPath.pattern) !== null,
    },
    {
      title: "Playlists & Stations",
      url: playlistsPath({}),
      icon: ListMusic,
      isActive: useMatch({ path: playlistsPath.pattern, end: false }) !== null,
    },
    {
      title: "Tracks",
      url: tracksPath({}),
      icon: Music,
      isActive: useMatch({ path: tracksPath.pattern, end: false }) !== null,
    },
    {
      title: "Schedules",
      url: schedulesPath({}),
      icon: Calendar,
      isActive: useMatch({ path: schedulesPath.pattern, end: false }) !== null,
    },
    {
      title: "Voice Messages",
      url: voiceMessagesPath({}),
      icon: MessageSquare,
      isActive: useMatch({ path: voiceMessagesPath.pattern, end: false }) !== null,
    },
    {
      title: "Voice Playlist Requests",
      url: voicePlaylistRequestsPath({}),
      icon: ClipboardList,
      isActive:
        useMatch({ path: voicePlaylistRequestsPath.pattern, end: false }) !== null,
    },
    {
      title: "Reporting",
      url: reportingPath({}),
      icon: ChartPie,
      isActive: useMatch({ path: reportingPath.pattern, end: false }) !== null,
    },
    {
      title: "",
      url: "#",
      icon: Divide,
      isActive: false,
      divider: true,
    },
    {
      title: "Users",
      url: usersPath({}),
      icon: Users,
      isActive: useMatch({ path: usersPath.pattern, end: false }) !== null,
    },
    {
      title: "Zones",
      url: zonesPath({}),
      icon: MapPin,
      isActive: useMatch({ path: zonesPath.pattern, end: false }) !== null,
    },
    {
      title: "Settings",
      url: organizationSettingsPath({}),
      icon: Settings,
      isActive: useMatch({ path: organizationSettingsPath.pattern, end: false }) !== null
    },
  ]

  const navSecondary: any[] = [
    // {
    //   title: "Support",
    //   url: "#",
    //   icon: LifeBuoy,
    // },
    // {
    //   title: "Feedback",
    //   url: "#",
    //   icon: Send,
    // },
  ]

  const user = React.useMemo(
    () => ({
      name: viewer.fullName,
      email: viewer.email,
      avatar: viewer.avatarThumbUrl ?? "",
    }),
    [viewer.fullName, viewer.email, viewer.avatarThumbUrl]
  )

  return (
    <Sidebar className="top-12 !h-[calc(100svh-3rem)]" {...props}>
      <SidebarHeader>
        <OrgSwitcher />
      </SidebarHeader>
      <SidebarContent>
        <NavMain items={navMain} />
        {/* <NavProjects projects={data.projects} /> */}
        <NavSecondary items={navSecondary} className="mt-auto" />
      </SidebarContent>
      <SidebarFooter>
        <NavUser user={user} />
      </SidebarFooter>
    </Sidebar>
  )
}
